import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=f2f7e0f6&"
import script from "./SubmitButton.vue?vue&type=script&lang=ts&"
export * from "./SubmitButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f7e0f6')) {
      api.createRecord('f2f7e0f6', component.options)
    } else {
      api.reload('f2f7e0f6', component.options)
    }
    module.hot.accept("./SubmitButton.vue?vue&type=template&id=f2f7e0f6&", function () {
      api.rerender('f2f7e0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/SubmitButton.vue"
export default component.exports